import { TrelloWindow } from '@trello/window-types';

declare const window: TrelloWindow;
let supportedLocales: string[];

export function getSupportedLocales() {
  if (supportedLocales) {
    return supportedLocales;
  }

  supportedLocales = Object.keys(window.__bundles)
    .filter((bundle) => bundle.startsWith('locale.'))
    .map((bundle) => bundle.replace(/^locale\./, ''));

  return supportedLocales;
}
